<div class="container">
  <div class="navigate-chips">
    <div matRipple class="order-chips" [class.active]="activatedState === 'thesis'" *ngIf="activatedState === 'thesis'">
      <h3>سفارش پایان‌نامه</h3>
    </div>
    <div matRipple class="order-chips" [routerLink]="['/thesis-editing']"><h3>ویرایش پایان‌نامه</h3></div>
  </div>
  
  <app-thesis-edit-order
    [state]="activatedState"
    *ngIf="activatedState === 'edit'"
    (changeState)="changeStateTo($event)"
  >
  </app-thesis-edit-order>
  
  <div *ngIf="activatedState === 'thesis'" class="print-order-container" @fadeInOut>
    <mat-card class="print-order-card">
      <section
        *ngIf="tarefeOptions && !(isHandset$ | async)"
        id="tarefe"
        [@tarefeToggle]="tarefeToggle && !(isHandset$ | async) ? 'open' : 'close'"
        [class.displayOver]="(isHandset$ | async)! && tarefeToggle"
        (click)="$event.stopPropagation()"
      >
        <app-tarefe
          [options]="tarefeOptions"
          [(toggle)]="tarefeToggle"
        ></app-tarefe>
      </section>
  
      <div
        *ngIf="this.bindings.length <= 0 && this._typings.length <= 0"
        id="overlay"
        fxLayout="row"
        fxLayoutAlign="center center"
      >
        <mat-spinner></mat-spinner>
      </div>
  
      <mat-card-title class="title button-container">
        <div
          style="background-color: transparent"
          fxLayout="row"
          fxLayoutAlign="space-between center"
        >
          <public-file-upload
            (status)="onStatus($event)"
            (file)="saveFileUploadReport($event)"
            name="main"
            id="uploadMain"
          >
          </public-file-upload>
          <span style="color: var(--primary)">{{
            statusText || " " | digitsEnToFa
          }}</span>
  
          <div
            (click)="startHelp()"
            class="help"
            fxLayout="row"
            fxLayoutAlign="space-between center"
          >
            <span> راهنما </span>
            <div class="help-icon" fxLayout="center" fxLayoutAlign="center">
              ؟
            </div>
          </div>
        </div>
      </mat-card-title>
  
      <mat-card-content>
        <form [formGroup]="orderFormGroup">
          <div
            class="block"
            fxLayout="row wrap"
            fxLayoutAlign="space-between center"
          >
            <mat-form-field
              [fxFlex]="defaultInputBlockSize"
              fxFlex.md="65"
              fxFlex.lt-md="49"
              id="print-color"
              appearance="outline"
              id="printColor"
              matTooltip="چاپ رنگی و یا سیاه و سفید  را نسبت به نیاز خود انتخاب کنید"
            >
              <mat-label> نوع چاپ </mat-label>
  
              <mat-select formControlName="pageColor">
                <mat-option [value]="printColorsConst.BLACK_WHITE">
                  سیاه و سفید
                </mat-option>
  
                <mat-option [value]="printColorsConst.COLORFUL">
                  رنگی
                </mat-option>
  
                <mat-option [value]="printColorsConst.HALF_COLORFUL">
                  نیمه رنگی
                </mat-option>
  
                <mat-option selected [value]="printColorsConst.MIXED">
                  ترکیبی
                </mat-option>
              </mat-select>
            </mat-form-field>
  
            <app-print-btn-toggle
              id="printBtnToggle"
              class="print-btn-toggle"
              (change)="setTwoSided($event)"
              [fxFlex]="defaultInputBlockSize"
              fxFlex.lt-md="48"
            ></app-print-btn-toggle>
  
            <div
              class="every-page-price-thesis"
              fxFlex="30"
              fxLayout="column"
              fxLayoutAlign="center center"
              *ngIf="!(isHandset$ | async)"
            >
              <span *ngIf="this.pageColor?.value !== 'mixed'">
                قیمت هر برگ
                {{ getPriceofSelectedOnePage() || 0 | irc : "T" | digitsEnToFa }}
              </span>
              <span *ngIf="this.pageColor?.value === 'mixed'">
                قیمت هر برگ ۰ تومان
              </span>
            </div>
          </div>
  
          <div
            class="block"
            fxLayout="row wrap"
            fxLayoutAlign="space-between center"
          >
            <div
              class="total-range"
              fxFlex="65"
              fxFlex.xs="100"
              fxFlex.md="100"
              fxFlex.sm="100"
              fxLayout="row"
              fxLayoutAlign="center stretch"
              id="pageRange"
            >
              <mat-form-field
                fxFlex="50"
                class="print-range-form"
                appearance="outline"
                fillable="false"
                (click)="printAllInputToggle()"
              >
                <mat-label>تعداد صفحات</mat-label>
                <input
                  matInput
                  type="number"
                  inputmode="numeric"
                  formControlName="customPageNo"
                  (click)="printAllInputToggle()"
                  (keyup)="printAllInputToggle()"
                />
              </mat-form-field>
              <div
                class="print-all like-mat-form-field"
                [ngClass]="{ 'disabled-field': beforeUpload }"
                fxFlex="50"
                fxLayout="row"
                fxLayoutAlign="space-between center"
                (click)="printAllCheckboxToggle()"
              >
                <span class="title">
                  همه صفحات
                  <span *ngIf="(pageNo?.value || 0) > 0"
                    >({{ pageNo?.value || 0 }})</span
                  >
                </span>
  
                <mat-checkbox
                  #printAllCheckbox
                  color="primary"
                  formControlName="printAll"
                  class="all-page-print-checkbox"
                >
                </mat-checkbox>
              </div>
            </div>
  
            <div
              class="print-copies-num"
              [fxFlex]="defaultInputBlockSize"
              fxFlex.md="100"
              fxFlex.sm="100"
              fxFlex.xs="100"
            >
              <mat-form-field
                id="copiesNumber"
                style="width: 100%"
                appearance="outline"
              >
                <mat-label>تعداد نسخه</mat-label>
                <input
                  #printCopiesNo
                  matInput
                  type="number"
                  formControlName="copies"
                  min="1"
                />
                <div class="arrows" matSuffix fxLayout="column">
                  <jam-icon
                    matRipple
                    (click)="
                      copies?.setValue((+printCopiesNo.value + 1).toString())
                    "
                    color="warn"
                    name="plus"
                  ></jam-icon>
                  <jam-icon
                    (click)="
                      copies?.setValue((+printCopiesNo.value - 1).toString())
                    "
                    matRipple
                    color="warn"
                    name="minus"
                  ></jam-icon>
                </div>
              </mat-form-field>
            </div>
          </div>
  
          <div
            class="block"
            fxLayout="row wrap"
            fxLayoutAlign="space-between center"
          >
            <mat-form-field
              class="bindings-select"
              [fxFlex]="defaultInputBlockSize"
              fxFlex.md="50"
              fxFlex.lt-md="48"
              appearance="outline"
              id="printBinding"
            >
              <mat-label>انتخاب صحافی</mat-label>
              <mat-select formControlName="binding">
                <mat-option [value]="0">کاور </mat-option>
                <mat-option *ngFor="let binding of bindings" [value]="binding.id">
                  {{ binding.name }}
                </mat-option>
              </mat-select>
            </mat-form-field>
  
            <div
              class="every-page-price-thesis"
              fxFlex="50"
              fxLayout="column"
              fxLayoutAlign="center center"
              *ngIf="isHandset$ | async"
            >
              <span *ngIf="this.pageColor?.value !== 'mixed'">
                قیمت هر برگ
                {{ getPriceofSelectedOnePage() || 0 | irc : "T" | digitsEnToFa }}
              </span>
              <span *ngIf="this.pageColor?.value === 'mixed'">
                قیمت هر برگ ۰ تومان
              </span>
            </div>
  
            <shared-file-placeholder
              id="coverImagePlaceholder"
              (remove)="removeImageFromSelectedImages($event)"
              (onFileSelect)="selectImage('cover', $event)"
              name="coverImage"
              [selectable]="true"
              [fileType]="acceptableFileUploadTypes"
              [immediateUpload]="true"
              #coverImageFilePlaceholder
              placeholder="طرح روی جلد"
              uploadButtonTitle="آپلود طرح روی جلد"
              urlName=""
              fxFlex="65"
              fxFlex.lt-md="100"
              [layouts]="[50, 50]"
              [isImage]="true"
            ></shared-file-placeholder>
          </div>
  
          <div class="block">
            <div
              id="talcColorSelector"
              class="talc-color"
              fxFlex="100"
              fxFlex.lt-md="100"
            >
              <app-talc-color-selector
                style="width: 100%; display: block"
                [class.disabled]="!binding?.value && binding?.value === 0"
                [(talcColors)]="talcColors"
                [(selected)]="selectedTalcColor"
                [disabled]="!binding?.value && binding?.value === 0 && !needsTalc()"
              ></app-talc-color-selector>
            </div>
          </div>
  
          <!-- Select files ------------------------------------- -->
          <div
            class="block"
            fxLayout="row wrap"
            fxLayoutAlign="space-around baseline"
          >
            <shared-file-placeholder
              (remove)="removeImageFromSelectedImages($event)"
              (onFileSelect)="selectImage('signature', $event)"
              [immediateUpload]="true"
              [isImage]="true"
              [fileType]="acceptableFileUploadTypes"
              #signatureFilePlaceholder
              name="instructorSignature"
              [selectable]="true"
              placeholder="صفحه امضای استاد"
              uploadButtonTitle="آپلود امضای استاد"
              id="instructorSignaturePlaceholder"
              urlName=""
              fxFlex="100"
              [layouts]="[68, 32]"
            ></shared-file-placeholder>
          </div>
  
          <div
            class="block print-block-selectors"
            fxLayout="row"
            fxLayoutAlign="space-between center"
            fxLayout.lt-md="column"
            [class.disabled]="pageColor?.value !== 'mixed'"
          >
            <print-mixed-range-select
              fxFlex="49"
              fxFlex.lt-md="100"
              style="width: 100%"
              [type]="halfColorfulType"
              [typings]="flatTypings!"
              [(blocks)]="printBlocks"
              (onChange)="updateOrderPrice()"
              title="صفحات نیمه رنگی"
              id="halfColorRangeSelect"
              [disabled]="pageColor?.value !== 'mixed' || beforeUpload"
            ></print-mixed-range-select>
  
            <print-mixed-range-select
              fxFlex="49"
              fxFlex.lt-md="100"
              style="width: 100%"
              [type]="colorfulType"
              [typings]="flatTypings!"
              [(blocks)]="printBlocks"
              (onChange)="updateOrderPrice()"
              title="صفحات رنگی"
              id="fullColorRangeSelect"
              [disabled]="pageColor?.value !== 'mixed' || beforeUpload"
            ></print-mixed-range-select>
          </div>
  
          <div class="block" fxLayout="row" fxLayoutAlign="center center">
            <mat-form-field
              id="printOrderExtraInformation"
              class="textarea"
              fxFlex="100"
              appearance="outline"
            >
              <mat-label>توضیحات بیشتر</mat-label>
              <textarea
                formControlName="moreDetails"
                matInput
                placeholder="توضیحات سفارش ..."
              ></textarea>
            </mat-form-field>
          </div>
  
          <div class="block" fxLayout="row">
            <app-submit-btn
              [title]="!editMode ? 'افزودن به سبد خرید' : 'ویرایش سفارش'"
              id="submitBtn"
              fxFlex="49"
              fxFlex.md="100"
              fxFlex.sm="100"
              fxFlex.xs="100"
              [anim-options]="submitAnimationOptions"
              (animationStart)="submit()"
              *ngIf="isHandset$ | async"
              [anim-style]="mobileSubmitAnimationStyle"
            >
            </app-submit-btn>
          </div>
        </form>
      </mat-card-content>
    </mat-card>
  
    <!-- <div class="spaceer" fxFlex="2"></div> -->
  
    <div
      id="copiesInput"
      fxLayout="column"
      fxLayoutAlign="center end"
      fxFlex="40"
      fxFlex.lt-md="100"
      *ngIf="!(isHandset$ | async)"
    >
      <div class="animation-placeholder"></div>
      <div class="submit" fxFlex="100" fxLayoutAlign="center stretch">
        <div id="totalPriceSection" class="total-price" fxFlex="49">
          <span class="title"> قیمت کل </span>
          <span class="price" fxLayout="column" fxLayoutAlign="center center">
            {{ price || 0 | irc : "T" | digitsEnToFa }}
          </span>
        </div>
  
        <app-submit-btn
          [class.disabled]="!this.orderFormGroup.valid || !this.fileUploadReport"
          [title]="!editMode ? 'افزودن به سبد خرید' : 'ویرایش سفارش'"
          [anim-options]="submitAnimationOptions"
          (animationStart)="submit()"
          fxFlex.md="100"
          fxFlex.sm="100"
          fxFlex.xs="100"
          id="submitBtn"
          fxFlex="60"
        >
        </app-submit-btn>
      </div>
    </div>
  </div>
</div>

<app-dynamic-content
  *ngIf="printConfigs && printConfigs['why_ziraxi']"
  [config]="printConfigs"
></app-dynamic-content>
